export default __webpack_public_path__ + "static/media/3.3f44fda2.png";